import classNames from "classnames";
import { globalProps } from "neetocommons/initializers";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { CheckCircle } from "neetoicons";
import { Dropdown as NeetoUIDropdown, Tag } from "neetoui";
import { useTranslation } from "react-i18next";

import { useFetchLoggedInOrganizations } from "./hooks/reactQuery/useFetchLoggedInOrganizations.js";
import MenuItemButton from "./MenuButton";

const { Menu, MenuItem } = NeetoUIDropdown;

const OrganizationSwitcher = () => {
  const { t } = useTranslation();
  const { isSize } = useBreakpoints();

  const { data: { organizations, authAppUrl } = {} } =
    useFetchLoggedInOrganizations(globalProps?.user?.email);

  const isMobile = isSize("mobile");

  const isCurrentSubdomain = link => {
    const currentSubdomain = window.location.hostname.split(".")[0];
    const linkSubdomain = new URL(link).hostname.split(".")[0];

    return currentSubdomain === linkSubdomain;
  };

  return (
    <NeetoUIDropdown
      className="neeto-molecules-organization-switcher-menu-popup-wrapper"
      closeOnSelect={false}
      customTarget={<MenuItemButton />}
      interactiveDebounce={30}
      offset={[0, 5]}
      position={isMobile ? "bottom" : "right"}
      trigger="all"
      zIndex={99999}
    >
      <Menu>
        {organizations?.map(organization => (
          <MenuItem.Button
            href={organization.organizationUrl}
            key={organization.userId}
            rel="noreferrer"
            style="text"
            target="_blank"
            className={classNames({
              "neeto-molecules-organization-switcher-active-button":
                isCurrentSubdomain(organization.organizationUrl),
            })}
          >
            {organization.orgName}
            {isCurrentSubdomain(organization.organizationUrl) && (
              <Tag
                icon={() => <CheckCircle size={12} />}
                size="small"
                style="primary"
                type="solid"
              >
                {t("neetoMolecules.sidebar.organizationSwitcher.signedin")}
              </Tag>
            )}
          </MenuItem.Button>
        ))}
        <MenuItem.Button href={authAppUrl} rel="noreferrer" target="_blank">
          {t("neetoMolecules.sidebar.organizationSwitcher.addAccount")}
        </MenuItem.Button>
      </Menu>
    </NeetoUIDropdown>
  );
};

export default OrganizationSwitcher;
